export default {
    data() {
        return {
            licenses : [
                {
                    "title"     : "VUE.js",
                    "subTitle"  : "",
                    "licenses"  : [
                        {
                            "title" : "MIT",
                            "url"   : "https://opensource.org/licenses/MIT"
                        }
                    ],
                    "text"      : "JavaScrip Framwork",
                    "url"       : "https://vuejs.org/",
                    "avatar"    : "/static/logos/png/vue-js-logo.png"
                },
                {
                    "title"     : "Vuetify.js",
                    "subTitle"  : "",
                    "licenses"  : [
                        {
                            "title" : "MIT",
                            "url"   : "https://opensource.org/licenses/MIT"
                        }
                    ],
                    "text"      : "JavaScrip Framwork",
                    "url"       : "https://vuetifyjs.com",
                    "avatar"    : "/static/logos/png/vuetify-js-logo.png"
                },
                {
                    "title"     : "Vuelidate.js",
                    "subTitle"  : "",
                    "licenses"  : [
                        {
                            "title" : "MIT",
                            "url"   : "https://opensource.org/licenses/MIT"
                        }
                    ],
                    "text"      : "Vue.JS Validator Framwork",
                    "url"       : "https://vuelidate.js.org",
                    "avatar"    : "/static/logos/svg/default-logo.svg"
                },
                {
                    "title"     : "Material Design Icons",
                    "subTitle"  : "",
                    "licenses"  : [
                            {   "title" : "WTFPL",
                                "url"   : "http://www.wtfpl.net/"
                            }, {
                                "title" : "SIL Open Font License 1.1",
                                "url"   : "https://scripts.sil.org/cms/scripts/page.php?item_id=OFL_web"
                            },{
                                "title" : "Apache License 2.0",
                                "url"   : "https://github.com/google/material-design-icons/blob/master/LICENSE"
                            }
                    ],
                    "text"      : "Icons Library",
                    "url"       : "https://materialdesignicons.com/",
                    "avatar"    : "/static/logos/svg/default-logo.svg"
                },
                {
                    "title"     : "Vue Currency Input",
                    "subTitle"  : "",
                    "licenses"  : [
                        {
                            "title" : "MIT",
                            "url"   : "https://opensource.org/licenses/MIT"
                        }
                    ],
                    "text"      : "Easy input of currency formatted numbers for Vue.js",
                    "url"       : "https://dm4t2.github.io/vue-currency-input/",
                    "avatar"    : "/static/logos/png/vue-js-logo.png"
                },
                {
                    "title"     : "Moment JS",
                    "subTitle"  : "",
                    "licenses"  : [
                        {
                            "title" : "MIT",
                            "url"   : "https://opensource.org/licenses/MIT"
                        }
                    ],
                    "text"      : "A lightweight JavaScript date library for parsing, validating, manipulating, and formatting dates.",
                    "url"       : "https://momentjs.com/",
                    "avatar"    : "/static/logos/png/momentjs-logo.png"
                },
            ],
        };
    },
    // created() {
    //
    // },
    // computed: {
    //
    // },
    // methods: {
    // },
};
